import React, { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';


function AddOption({ onOptionAdded }) {
    const [show, setShow] = useState(false);
    const [name, setName] = useState('');

    const handleClose = () => {
        setShow(false);
        setName('');
    };

    const handleShow = () => setShow(true);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/admin/option/create`,
                { name },
            );

            if (response.data.success) {
                CustomToast.success(response.data.message);
                handleClose();
                if (onOptionAdded) onOptionAdded();
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response.data.message);
        }
    };
    const handleReset = () => {
        setName('');
    }

    return (
        <>
            <button className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-3' onClick={handleShow} >
                <img src="/images/png/plus.png" width={22} alt="" />
                Add Option
            </button>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>New Option</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-12">
                            <Form.Group controlId="email">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="title"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter name"
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center gap-3 mt-4'>
                        <button className='btn-outline fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-5' onClick={handleReset}>
                            Reset
                        </button>
                        <button className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-5' onClick={handleSubmit}>
                            Add
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddOption